export enum RecruitingPortalType {
  Medlo = "Medlo",
  Avropsportalen = "Avropsportalen",
  Inkopio = "Inkopio",
  Bemlo = "Bemlo",
  Nemo = "Nemo"
}
